import React from 'react';
import { getText } from '../../utils/functions';
import FormLabel from './FormLabel';
import { useIntelliTags } from '../../utils/hooks';

function AditionalText({
	id,
	portal,
	text,
	translate,
	colors,

	/* Optional Props */
	className = 'flex font-lato justify-start text-justify flex-col md:flex-row pb-4',
	style,
}) {
	/* Default values for the styles */
	const defaultStyle = {
		color: colors?.text,
	};

	let aditionalTextPosition;

	if (portal?.config?.forms?.aditionalText?.position === 'up') {
		aditionalTextPosition = 'flex flex-col space-y-8 order-first';
	} else {
		aditionalTextPosition = 'flex flex-col space-y-8';
	}

	/* This allows for only one of the fields to be modified and still keep the other constant values */
	const overrideStyle = { ...defaultStyle, ...style };

	const { applyIntelliTags } = useIntelliTags({ portal, translate });

	return <React.Fragment>
		<div className={aditionalTextPosition}>
			{portal?.config?.forms?.aditionalTextTitle?.isActive && <FormLabel
				text={portal?.config?.forms?.aditionalTextTitle}
				colors={colors}
				translate={translate}
			/>}
			<div
				id={id}
				className={className}
				style={overrideStyle}
				dangerouslySetInnerHTML={{
					__html: applyIntelliTags(
						getText(text, translate)
					)
				}}
			></div>
		</div>
	</React.Fragment>;
}

export default AditionalText;
